import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { cleanMeetingNotes } from '../../components/HealthCoachDashboard/utils';
import { MeetingNote } from '../types';

export const useMeetingNotes = (userId: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchMeetingNotes = async () => {
    const requestObj = {
      route: `/private/coach-meeting-notes/?user_uuid=${userId}`,
      token: userToken,
    };

    const meetingNotes = await api(requestObj);

    return meetingNotes.map(cleanMeetingNotes);
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    MeetingNote[],
    Error
  >(['hc-meeting-notes', userToken, userId], () => fetchMeetingNotes(), {
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    meetingNotes: data,
    isInitialLoading,
    isLoading,
    isError,
  };
};
